<!--
 * @Descripttion: 
 * @Author: liaoyijun
 * @Date: 2021-08-18 11:11:00
 * @LastEditors: liaoyijun
 * @LastEditTime: 2021-08-19 11:38:13
-->
<template>
    <div class="notice-index">
        <div class="body-title">消息通知</div>
        <div class="nav-btn">
            <div class="inline-block">
                <!-- icon="el-icon-delete" -->
                <el-button
                    type
                    size="small"
                    icon="iconfont icon-shanchu3 icon-markRead"
                    :disabled="!selectIds.length > 0"
                    @click="handleDelete"
                >
                    删除
                </el-button>
                <el-button
                    type
                    :disabled="!selectIds.length > 0"
                    size="small"
                    icon="iconfont icon-yidu- icon-markRead"
                    @click="handleBatchMarkRead"
                >
                    批量标记已读
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    :disabled="total === 0"
                    icon="iconfont icon-yidu- icon-markRead"
                    @click="handelAllRead"
                >
                    全部已读
                </el-button>
            </div>
            <div class="inline-block float-right">
                <el-select v-model="messageType" :style="{ width: '120px' }" size="small" @change="handleTypeSearch">
                    <el-option
                        v-for="(type, index) of types"
                        :key="index"
                        :label="type.name"
                        :value="type.value"
                    ></el-option>
                </el-select>
                <el-input
                    v-model="keyword"
                    class="search-keyword"
                    :style="{ width: '200px' }"
                    size="small"
                    placeholder="搜索关键字"
                    @keyup.enter.native="handleKeyWordSearch"
                    @change="handleKeyWordSearch"
                >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleKeyWordSearch"></i>
                </el-input>
            </div>
        </div>
        <div class="notice-table">
            <el-table
                :key="tableKey"
                :header-cell-style="{ background: '#F9F9F9' }"
                :data="tableData"
                :height="tableHeight"
                style="width: 100%"
                @select="handleSelectChange"
                @select-all="handleSelectAll"
            >
                <el-table-column type="selection" width="45"></el-table-column>
                <el-table-column label="全选">
                    <template slot-scope="scope">
                        <div v-if="!scope.row.ifRead" class="red-dot iconfont icon-yuandian"></div>
                        <div
                            :class="{
                                'unread-message-title': !scope.row.ifRead,
                                'read-message-title': scope.row.ifRead,
                                'detail-row': scope.row.url,
                            }"
                            class="main-content"
                            @click.stop="handleRedirect(scope.row)"
                        >
                            {{ scope.row.title }}
                        </div>
                        <div
                            class="sub-content"
                            :class="{
                                'unread-message-subtitle': !scope.row.ifRead,
                                'read-message-subtitle': scope.row.ifRead,
                            }"
                        >
                            {{ scope.row.createDate }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column width="50">
                    <template slot-scope="scope">
                        <div
                            v-if="detailShow(scope.row, 1)"
                            title="查看详情"
                            class="iconfont icon-wenben"
                            @click.stop="handleRedirect(scope.row)"
                        ></div>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-if="!scope.row.ifRead"
                            type="primary"
                            size="small"
                            @click.stop="handelMarkRead(scope.row)"
                        >
                            标记为已读
                        </el-button>
                        <div
                            v-if="detailShow(scope.row, 2)"
                            title="查看详情"
                            class="iconfont icon-wenben"
                            @click.stop="handleRedirect(scope.row)"
                        ></div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-pagination-wrapper">
                <el-pagination
                    v-show="total > 0"
                    class="paddingR10"
                    :page-size="params.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page.sync="params.current"
                    :total="total"
                    :page-sizes="[10, 15, 30, 50, 100]"
                    @size-change="handleSizeChange"
                    @current-change="getData"
                ></el-pagination>
            </div>
        </div>
        <!-- 日程消息详情弹框 -->
        <schedule-dialog
            v-if="scheduleDialogShow"
            :sc-detail="scDetail"
            edit-part="EDIT_NO"
            :schedule-dialog-show="scheduleDialogShow"
            @handleClose="scheduleDialogShow = false"
        ></schedule-dialog>

        <!-- 预约日程消息详情弹框 -->
        <deal-schedule-dialog
            v-if="handleScheduleDialogShow"
            :deal-schedule-dialog="handleScheduleDialogShow"
            :order-detail="orderSchduleDetail"
            @handleSuccess="handleSuccess"
            @handleClose="handleScheduleDialogShow = false"
        ></deal-schedule-dialog>
    </div>
</template>
<script>
export default {
    name: "NoticeIndex",
};
</script>
<script>
import scheduleDialog from "./schdule-detail";

import dealScheduleDialog from "./deal-schedule-dialog";

export default {
    name: "NoticeIndex",
    components: {
        scheduleDialog,
        dealScheduleDialog,
    },
    data() {
        return {
            api_get_data: "/admin/userMessage/list",
            api_delete_data: "/admin/userMessage/delete",
            api_post_setRead: "/admin/userMessage/setRead",
            api_get_type: "/admin/userMessage/getTypes",

            // 日程消息详情弹框
            scheduleDialogShow: false,
            scDetail: null, // 日程详情数据
            // 预约日程详情弹框
            handleScheduleDialogShow: false,
            orderSchduleDetail: "",

            tableKey: "tablekey",
            keyword: "",
            messageType: "",
            params: {
                keyword: "",
                type: "",
                current: 1,
                size: 15,
            },
            total: 0,
            loading: false,
            types: [],
            tableData: [],
            selectIds: [],
            tableHeight: null,
        };
    },
    mounted() {
        this.tableHeight = window.innerHeight - 223;
        this.search();
        this.getTypes();
    },
    methods: {
        getData() {
            this.tableData = [];
            this.loading = true;
            this.$axios
                .get(this.api_get_data, this.params)
                .then((res) => {
                    this.loading = false;
                    if (res.body) {
                        this.total = res.body.total;
                        this.tableData = res.body.records;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        // 删除
        handleDelete() {
            this.$axios.delete(this.api_delete_data, { ids: this.selectIds.join() }).then((res) => {
                this.selectIds = [];
                this.search();
            });
        },
        // 全部标记已读
        handelAllRead() {
            this.$axios.post(this.api_post_setRead, { type: 2, ids: [] }).then((res) => {
                this.selectIds = [];
                this.search();
                this.$store.dispatch("setUnreadTotal");
            });
        },
        // 批量标记已读
        handleBatchMarkRead() {
            this.$axios.post(this.api_post_setRead, { type: 1, ids: this.selectIds }).then((res) => {
                this.selectIds = [];
                this.search();
                this.$store.dispatch("setUnreadTotal");
            });
        },
        // 标记已读
        handelMarkRead(row) {
            this.$axios.post(this.api_post_setRead, { type: 1, ids: [row.id] }).then((res) => {
                this.search();
                this.$store.dispatch("setUnreadTotal");
            });
        },
        // 当用户手动勾选数据行的 Checkbox 时触发的事件
        handleSelectChange(selection, row) {
            if (selection.length > 0) {
                this.selectIds = selection.map((s) => s.id);
            } else {
                this.selectIds = [];
            }
        },
        // 当用户手动勾选全选 Checkbox 时触发的事件
        handleSelectAll(selection) {
            if (selection) {
                this.selectIds = selection.map((s) => s.id);
            } else {
                this.selectIds = [];
            }
        },
        handleKeyWordSearch() {
            this.params.keyword = this.keyword;
            this.search();
        },

        // 分类查询
        handleTypeSearch() {
            this.params.type = this.messageType;
            this.search();
        },
        /**
         * 分页变化
         * @param val
         */
        handleSizeChange(val) {
            this.params.size = val;
            this.search();
        },
        search() {
            this.params.current = 1;
            this.getData();
        },
        // 网页跳转
        handleRedirect(row) {
            debugger;
            if (!row.url) return;
            if (!row.ifRead) {
                this.handelMarkRead(row);
            }
            // 日程详情
            if (row.type === 1) {
                this.scDetail = null;
                let str = row.url.slice(row.url.indexOf("scheduleId"), row.url.indexOf("&editType"));
                let id = str.replace("scheduleId=", "");
                this.$axios.get(`/schedule/management/detail/${id}`).then((res) => {
                    if (res.body) {
                        this.scDetail = res.body;
                        this.scheduleDialogShow = true;
                    }
                });
                // 预约日程详情
            } else if (row.type === 6) {
                this.$axios.get(`/schedule/appointment/detail/${row.url}`).then((res) => {
                    this.orderSchduleDetail = res.body;
                    this.handleScheduleDialogShow = true;
                });
            } else {
                // this.handleRouterJump(1, row.url, "", true);
                window.open(row.url);
            }
        },
        handleSuccess() {
            this.handleScheduleDialogShow = false;
            this.getData();
        },
        // 获取类型
        getTypes() {
            this.$axios.get(this.api_get_type).then((res) => {
                this.types = res.body;
                this.types.unshift({ name: "全部类型", value: "" });
            });
        },
        detailShow(row, type) {
            // type =1 未读列的 详情按钮 ，type === 2 操作列的详情按钮
            if (type === 1) {
                if (!row.ifRead && row.url) {
                    return true;
                } else return false;
            } else if (type === 2) {
                if (row.ifRead && row.url) {
                    return true;
                } else return false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.notice-index {
    .body-title {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .nav-btn {
        margin-top: 20px;
        .inline-block {
            display: inline-block;
        }
        .float-right {
            float: right;
        }
        .search-keyword {
            margin-left: 10px;
        }
    }
    .notice-table {
        margin-top: 20px;
        .main-content {
            display: inline-block;
            font-size: 14px;
        }
        .unread-message-title {
            color: #000000;
        }
        .read-message-title {
            // color: #666666;
            color: #999;
        }
        .sub-content {
            font-size: 14px;
        }
        .unread-message-subtitle {
            color: #666666;
            margin-left: 30px;
        }
        .read-message-subtitle {
            color: #999999;
            margin-left: 10px;
        }
        .red-dot {
            color: #fc615d;
            display: inline-block;
        }
    }
    .page-pagination-wrapper {
        padding: 10px 0;
        float: right;
    }
}
</style>
